const tableHeader = ['', 'Biedkoers', 'NAV', 'Laatkoers'];
export const BNLRatesMonth: React.FC<{ monthName: string; ratesData: number[][] }> = ({ monthName, ratesData }) => {
    return (
        <div className="flex flex-col m-4 text-sm m-5 sm:m-12">
            <span className="flex justify-start items-center pb-6 text-xl font-medium">{monthName}</span>
            <table className="border border-black">
                <tbody>
                    <tr>
                        {tableHeader.map((title, index) => {
                            return (
                                <td className="p-0" key={index}>
                                    {/* width={`${index !== 0 ? '32%' : '4%'}`} */}
                                    <div
                                        className={`flex sm:${
                                            index !== 0 ? `w-24` : ''
                                        } flex-row justify-center items-center px-2 py-3 font-medium ${
                                            index !== 0 ? 'border-l' : ''
                                        } border-black`}
                                    >
                                        {title}
                                    </div>
                                </td>
                            );
                        })}
                    </tr>
                    {ratesData.map((rates, ratesIndex) => {
                        return (
                            <tr key={ratesIndex}>
                                <td className="p-0">
                                    <div className="flex justify-center items-center px-2 py-2 border-t border-black font-medium">
                                        {ratesIndex + 1}
                                    </div>
                                </td>
                                {rates.map((specificRate, specificRateIndex) => {
                                    return (
                                        <td className="p-0" key={specificRateIndex}>
                                            <div className="flex justify-center items-center px-4 py-2 border-l border-t border-black">
                                                {specificRate === -1
                                                    ? '-'
                                                    : specificRate.toLocaleString('nl-NL', {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                      })}
                                            </div>
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
